import type { AuthError } from '@/auth/auth-errors';
import { authErrorSchema } from '@/auth/auth-errors';
import { paths } from '@/routes/paths';

export type HandoffResult =
  | { status: 'success'; token: string }
  | { status: 'error'; reason: AuthError };

export function toAuthError(value: unknown): AuthError {
  const parsed = authErrorSchema.safeParse(value);
  return parsed.success ? parsed.data : 'auth_failed';
}

export function isHandoffUrl(url: URL): boolean {
  return (
    url.pathname === paths.authLogin ||
    (url.pathname === paths.login && url.searchParams.has('error'))
  );
}

export function readHandoffResult(url: URL): HandoffResult {
  if (url.pathname === paths.authLogin) {
    const token = url.searchParams.get('token');
    return token
      ? { status: 'success', token }
      : { status: 'error', reason: 'auth_failed' };
  }

  return { status: 'error', reason: toAuthError(url.searchParams.get('error')) };
}
